import { sagaEffects } from '../../../dependencies';

import updateAuthUserPassword from './updateAuthUserPassword';

const { all } = sagaEffects;

export default function* () {
    yield all([updateAuthUserPassword()]);
}
